import styles from './ImagedLink.module.css'
import { DSImagedLink } from 'shared-definitions/types'
import Linked from 'shared-components/service/Linked'
import AppImage from 'shared-components/ui/AppImage'
import clsx from 'clsx'

type ImagedLinkProps = DSImagedLink

const ImagedLink: React.VFC<ImagedLinkProps> = ({ image, pLink, label }) => {
  const imgSize = image?.size ?? { w: 16, h: 9 }
  const sizes = (50 / Math.min(imgSize.h, imgSize.w)) * Math.max(imgSize.w, imgSize.h)

  return (
    <Linked className={clsx(styles.container, { [styles.hasImage]: image !== null })} {...pLink}>
      {image && <AppImage layout="raw" image={image} sizes={sizes} className={styles.image} />}
      {label}
    </Linked>
  )
}

export default ImagedLink
